import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell
} from "recharts";
import ChartTooltip from "./ChartTooltip";

export default function BarChartCard({
  title,
  subtitle,
  data,
  dataKey = "value",
  labelKey = "label",
  formatter,
  angledLabels = false,
  className = ""
}) {
  const highlightIndex =
    data && data.length ? data.reduce((best, d, i, arr) => (d[dataKey] > arr[best][dataKey] ? i : best), 0) : -1;

  return (
    <div className={`chart-card ${className}`}>
      <div className="chart-card__head">
        <div>
          <div className="chart-card__title">{title}</div>
          {subtitle && <div className="chart-card__subtitle">{subtitle}</div>}
        </div>
      </div>
      <div className="chart-card__body">
        {!data || data.length === 0 ? (
          <div className="chart-card__empty">No data for this range.</div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: angledLabels ? 16 : 0 }}>
              <XAxis
                dataKey={labelKey}
                tickLine={false}
                axisLine={false}
                tick={{ fill: "var(--text-faint)", fontSize: 11 }}
                interval={0}
                angle={angledLabels ? -35 : 0}
                textAnchor={angledLabels ? "end" : "middle"}
                height={angledLabels ? 46 : 30}
              />
              <YAxis tickLine={false} axisLine={false} tick={{ fill: "var(--text-faint)", fontSize: 11 }} width={34} allowDecimals={false} />
              <Tooltip
                cursor={{ fill: "var(--surface-2)" }}
                content={<ChartTooltip formatter={formatter} />}
              />
              <Bar dataKey={dataKey} radius={[6, 6, 0, 0]} maxBarSize={40} isAnimationActive animationDuration={700}>
                {data.map((_, i) => (
                  <Cell key={i} fill={i === highlightIndex ? "var(--accent-2)" : "var(--accent)"} fillOpacity={i === highlightIndex ? 1 : 0.55} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
